/**
 * Schermate del LIVE attuale ancora mancanti dai mockup.
 * Tutte 1:1 con pagine reali presenti in /app/frontend/src/pages/.
 */
import React from 'react';
import {
  Pin, Calendar, Users, Bell, FileText, AlertTriangle, CheckCircle2, Clock,
  TrendingUp, Activity, Database, Server, Cpu, HardDrive, Wifi,
  ChevronRight, Plus, Shield, Wrench, BarChart3, Building2, Sparkles,
  AlertOctagon, GitBranch, RefreshCw, Settings, Archive, Crown, MessageSquare
} from 'lucide-react';
import { C, fontHead, overline, primaryBtn, secondaryBtn } from '../_tokens';

const Wrap = ({ children }) => (
  <div style={{ padding: '32px 36px', background: C.bg, color: C.text, fontFamily: 'Inter', minHeight: '100%' }}>{children}</div>
);
const PageHeader = ({ over, title, sub, action }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 24 }}>
    <div>
      <div style={{ ...overline, marginBottom: 6 }}>{over}</div>
      <h1 style={{ fontFamily: fontHead, fontSize: 32, fontWeight: 600, margin: 0,
                   letterSpacing: '-0.025em', lineHeight: 1 }}>{title}</h1>
      {sub && <div style={{ color: C.textSec, fontSize: 13, marginTop: 8 }}>{sub}</div>}
    </div>
    {action}
  </div>
);
const Card = ({ title, sub, action, children, accent }) => (
  <div style={{ background: C.surf, borderRadius: 14, padding: 22,
                border: `1px solid ${accent ? accent + '33' : C.border}` }}>
    {(title || action) && (
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 18 }}>
        <div>
          {title && <div style={{ fontFamily: fontHead, fontSize: 17, fontWeight: 600 }}>{title}</div>}
          {sub && <div style={{ fontSize: 11.5, color: C.textSec, marginTop: 3 }}>{sub}</div>}
        </div>
        {action}
      </div>
    )}
    {children}
  </div>
);

// ============================================================================
// 1. BACHECA (BoardPage live)
// ============================================================================
export function ScreenBoardLive() {
  return (
    <Wrap>
      <PageHeader over="Comunicazioni · Bacheca" title="Bacheca aziendale"
        sub="Post operativi e comunicazioni del gruppo · solo super_admin può creare"
        action={<button style={primaryBtn}><Plus size={13} /> Nuovo post</button>} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {[
          { p: true, title: 'Manutenzione sistema 18 Giugno', body: 'Il giorno 18/06 dalle 02:00 alle 04:00 sarà eseguito un aggiornamento del sistema. Possibili rallentamenti.', a: 'Marco R.', t: '2 giorni fa', cat: 'sistema' },
          { title: 'Nuova procedura silicone bagni', body: 'Da oggi tutte le siliconature vanno aperte come ticket separato categoria Siliconature, non più sotto Idraulica.', a: 'Marco R.', t: '5 giorni fa', cat: 'procedura' },
          { title: 'Riunione capi manutentori', body: 'Lunedì 16/06 ore 10:00 in sede. Argomento: pianificazione manutenzioni Q3.', a: 'Marco R.', t: '1 settimana fa', cat: 'meeting' },
        ].map((p, i) => (
          <div key={i} style={{
            background: C.surf, borderRadius: 12, padding: 20,
            border: `1px solid ${p.p ? C.gold + '44' : C.border}`,
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
              {p.p && <Pin size={12} color={C.gold} />}
              <span style={{ fontFamily: fontHead, fontSize: 16, fontWeight: 600 }}>{p.title}</span>
              <span style={{ fontSize: 9, fontWeight: 700, padding: '3px 7px', borderRadius: 4,
                            background: `${C.cyan}22`, color: C.cyan, letterSpacing: '0.1em', textTransform: 'uppercase' }}>{p.cat}</span>
            </div>
            <p style={{ fontSize: 13, color: C.text, opacity: 0.85, lineHeight: 1.5, margin: 0 }}>{p.body}</p>
            <div style={{ fontSize: 11.5, color: C.textSec, marginTop: 10 }}>{p.a} · {p.t}</div>
          </div>
        ))}
      </div>
    </Wrap>
  );
}

// ============================================================================
// 2. PREDICTIVE MAINTENANCE (live)
// ============================================================================
export function ScreenPredictive() {
  return (
    <Wrap>
      <PageHeader over="Maintenance · Predictive" title="Manutenzione predittiva"
        sub="Indicazioni basate su storico ticket reali · ranking camere/categorie a rischio" />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14, marginBottom: 18 }}>
        <Stat label="Camere segnalate" v="14" sub="≥ 3 ticket negli ultimi 60gg" c={C.terra} />
        <Stat label="Categoria critica" v="Idraulica" sub="38% dei ricorrenti" c={C.amber} />
        <Stat label="Hotel più segnalato" v="Galleria" sub="6 camere a rischio" c={C.gold} />
      </div>
      <Card title="Camere ad alto rischio" sub="Top 10 ordinate per ticket recenti / 60gg">
        <div style={{ display: 'grid',
                      gridTemplateColumns: '60px 100px 1fr 90px 100px 120px',
                      gap: 14, padding: '10px 14px', ...overline, borderBottom: `1px solid ${C.border}` }}>
          <span>#</span><span>Camera</span><span>Hotel</span><span>Ticket</span><span>Categ. prev.</span><span></span>
        </div>
        {[
          { r: '208', h: 'Galleria', n: 5, cat: 'Idraulica' },
          { r: '412', h: 'Scarlatti', n: 4, cat: 'Elettrica' },
          { r: '305', h: 'Galleria', n: 4, cat: 'HVAC' },
          { r: '1001', h: 'Kira', n: 3, cat: 'Idraulica' },
          { r: '512', h: 'Arcimboldi', n: 3, cat: 'Estetica' },
        ].map((c, i) => (
          <div key={c.r} style={{ display: 'grid',
                                  gridTemplateColumns: '60px 100px 1fr 90px 100px 120px',
                                  gap: 14, padding: '14px', borderBottom: `1px solid ${C.border}`,
                                  alignItems: 'center', fontSize: 13 }}>
            <span style={{ fontFamily: fontHead, fontWeight: 600, color: i < 3 ? C.terra : C.text }}>#{i + 1}</span>
            <span style={{ fontWeight: 600 }}>Cam {c.r}</span>
            <span style={{ color: C.textSec }}>{c.h}</span>
            <span style={{ fontFamily: fontHead, fontWeight: 600,
                           color: c.n >= 4 ? C.terra : C.amber }}>{c.n}</span>
            <span style={{ fontSize: 11, color: C.textSec }}>{c.cat}</span>
            <button style={{ ...secondaryBtn, fontSize: 11.5, padding: '6px 12px' }}>
              Apri manut. preventiva
            </button>
          </div>
        ))}
      </Card>
    </Wrap>
  );
}

// ============================================================================
// 3. TECHNICIAN PRODUCTIVITY (live)
// ============================================================================
export function ScreenTechProd() {
  return (
    <Wrap>
      <PageHeader over="Operations · Team performance" title="Produttività tecnici"
        sub="KPI mensili per tecnico · gruppo · giugno 2026" />
      <Card>
        <div style={{ display: 'grid',
                      gridTemplateColumns: '38px 1.5fr 100px 130px 100px 130px 100px',
                      gap: 14, padding: '10px 14px', ...overline, borderBottom: `1px solid ${C.border}`,
                      alignItems: 'center' }}>
          <span>#</span><span>Tecnico</span><span>Chiusi</span><span>MTTR medio</span>
          <span>SLA OK</span><span>Satisf. media</span><span></span>
        </div>
        {[
          { n: 'Sara Konti', r: 'Multi-skill', c: 47, mttr: '1h 04m', sla: 96, sat: 4.7, color: C.emerald },
          { n: 'Luca Marini', r: 'Idraulico', c: 38, mttr: '1h 22m', sla: 94, sat: 4.6, color: C.cyan },
          { n: 'Marco Trento', r: 'Elettricista', c: 32, mttr: '1h 35m', sla: 91, sat: 4.5, color: C.amber },
          { n: 'Diego Bo', r: 'HVAC', c: 28, mttr: '2h 18m', sla: 88, sat: 4.3, color: C.gold },
          { n: 'Anna Verde', r: 'HK', c: 21, mttr: '0h 48m', sla: 93, sat: 4.6, color: '#A78BFA' },
        ].map((t, i) => (
          <div key={t.n} style={{ display: 'grid',
                                  gridTemplateColumns: '38px 1.5fr 100px 130px 100px 130px 100px',
                                  gap: 14, padding: '14px', borderBottom: `1px solid ${C.border}`,
                                  alignItems: 'center', fontSize: 13 }}>
            <span style={{ fontFamily: fontHead, fontWeight: 700, color: i === 0 ? C.gold : C.textSec }}>#{i + 1}</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 28, height: 28, borderRadius: '50%', background: `${t.color}33`,
                            color: t.color, display: 'grid', placeItems: 'center', fontWeight: 600, fontSize: 11 }}>
                {t.n.split(' ').map(x => x[0]).join('')}
              </div>
              <div>
                <div style={{ fontWeight: 600 }}>{t.n}</div>
                <div style={{ fontSize: 11, color: C.textSec }}>{t.r}</div>
              </div>
            </div>
            <span style={{ fontFamily: fontHead, fontWeight: 600 }}>{t.c}</span>
            <span style={{ color: C.text }}>{t.mttr}</span>
            <span style={{ color: t.sla >= 92 ? C.emerald : C.amber, fontWeight: 600 }}>{t.sla}%</span>
            <span>⭐ {t.sat}/5.0</span>
            <button style={{ ...secondaryBtn, fontSize: 11.5, padding: '6px 12px' }}>Dettaglio</button>
          </div>
        ))}
      </Card>
    </Wrap>
  );
}

// ============================================================================
// 4. NOTIFICATION SETTINGS (live)
// ============================================================================
export function ScreenNotifSettings() {
  return (
    <Wrap>
      <PageHeader over="Account · Notifiche" title="Impostazioni notifiche"
        sub="Scegli quando e come essere notificato · webpush, email, in-app" />
      <Card title="Canali attivi">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {[
            { i: Bell, n: 'Notifiche push browser', on: true, sub: 'Mac + Windows · Chrome / Edge / Safari' },
            { i: MessageSquare, n: 'Notifiche in-app', on: true, sub: 'Sempre attive · centro notifiche in alto a destra' },
            { i: FileText, n: 'Email · digest giornaliero', on: false, sub: 'Riepilogo via mail ogni sera alle 19:00' },
            { i: FileText, n: 'Email · alert critici (RED)', on: true, sub: 'Solo per ticket URGENTE e alert consumi' },
          ].map((c, i) => (
            <div key={i} style={{
              display: 'flex', alignItems: 'center', gap: 14, padding: '14px 16px',
              background: 'rgba(255,255,255,0.018)', borderRadius: 10, border: `1px solid ${C.border}`,
            }}>
              <c.i size={18} color={c.on ? C.gold : C.textDim} />
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13.5, fontWeight: 600 }}>{c.n}</div>
                <div style={{ fontSize: 11.5, color: C.textSec, marginTop: 3 }}>{c.sub}</div>
              </div>
              <Toggle on={c.on} />
            </div>
          ))}
        </div>
      </Card>
      <div style={{ height: 16 }} />
      <Card title="Quando notificarmi">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {[
            ['Nuovo ticket URGENTE assegnato a me', true],
            ['Nuovo ticket ALTA priorità nel mio hotel', true],
            ['SLA in scadenza (-10 min)', true],
            ['Manutenzione programmata in scadenza', true],
            ['Alert consumi RED', true],
            ['Nuovo post in bacheca', false],
            ['Riepilogo settimanale', false],
          ].map(([label, on], i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px',
                                  borderRadius: 8, background: 'rgba(255,255,255,0.012)',
                                  border: `1px solid ${C.border}` }}>
              <span style={{ flex: 1, fontSize: 13 }}>{label}</span>
              <Toggle on={on} />
            </div>
          ))}
        </div>
      </Card>
    </Wrap>
  );
}

const Toggle = ({ on }) => (
  <div style={{ width: 42, height: 24, borderRadius: 12, padding: 3,
                background: on ? C.emerald : C.surfLight, transition: 'all 0.2s',
                display: 'flex', alignItems: 'center' }}>
    <div style={{ width: 18, height: 18, borderRadius: '50%', background: '#fff',
                  transform: on ? 'translateX(18px)' : 'translateX(0)', transition: 'all 0.2s' }} />
  </div>
);

// ============================================================================
// 5. ONLINE USERS (live)
// ============================================================================
export function ScreenOnlineUsers() {
  return (
    <Wrap>
      <PageHeader over="Sistema · Live presence" title="Utenti online ora"
        sub="14 utenti connessi · refresh ogni 30 secondi" />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 14, marginBottom: 18 }}>
        <Stat label="Online ora" v="14" sub="su 34 totali" c={C.emerald} />
        <Stat label="Picco oggi" v="22" sub="alle 09:42" c={C.gold} />
        <Stat label="Sessioni medie" v="2h 14m" sub="durata media" c={C.cyan} />
        <Stat label="Mobile vs Desktop" v="42 / 58 %" sub="oggi" c={C.amber} />
      </div>
      <Card title="Chi è online" sub="Hotel · ruolo · ultima attività">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {[
            ['Marco Rossi', 'Super Admin', 'Tutti', '12 sec fa', 'desktop'],
            ['Sara Konti', 'Capo Manutent.', 'Galleria', '34 sec fa', 'mobile'],
            ['Luca Marini', 'Tecnico', 'Galleria', '1 min fa', 'mobile'],
            ['Anna Verde', 'Front Office', 'Arcimboldi', '2 min fa', 'desktop'],
            ['Diego Bo', 'Hotel Manager', 'Scarlatti', '4 min fa', 'desktop'],
            ['Marco Trento', 'Tecnico', 'Galleria', '5 min fa', 'mobile'],
          ].map((u, i) => (
            <div key={i} style={{ display: 'grid',
                                  gridTemplateColumns: '20px 1.4fr 1fr 0.8fr 100px 70px',
                                  gap: 14, padding: '10px 14px', alignItems: 'center', fontSize: 13,
                                  background: 'rgba(255,255,255,0.012)',
                                  borderRadius: 8, border: `1px solid ${C.border}` }}>
              <span style={{ width: 8, height: 8, borderRadius: '50%', background: C.emerald,
                            boxShadow: `0 0 8px ${C.emerald}` }} />
              <span style={{ fontWeight: 600 }}>{u[0]}</span>
              <span style={{ color: C.textSec }}>{u[1]}</span>
              <span style={{ color: C.textSec, fontSize: 12 }}>{u[2]}</span>
              <span style={{ color: C.textSec, fontSize: 12 }}>{u[3]}</span>
              <span style={{ fontSize: 11, padding: '3px 8px', borderRadius: 5,
                            background: u[4] === 'mobile' ? `${C.cyan}22` : `${C.gold}22`,
                            color: u[4] === 'mobile' ? C.cyan : C.gold, textAlign: 'center',
                            textTransform: 'uppercase', letterSpacing: '0.1em', fontWeight: 600 }}>{u[4]}</span>
            </div>
          ))}
        </div>
      </Card>
    </Wrap>
  );
}

// ============================================================================
// 6. PATCH NOTES / CHANGELOG (live)
// ============================================================================
export function ScreenPatchNotes() {
  return (
    <Wrap>
      <PageHeader over="Release notes" title="Changelog HostFix"
        sub="Tutte le novità versione per versione · ultima v3.0 del 10/06/2026"
        action={<button style={secondaryBtn}><FileText size={13} /> Scarica PDF completo</button>}
      />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        {[
          { v: 'v3.0', d: '10 Giugno 2026', tag: 'CURRENT', tagC: C.emerald, items: [
            { c: C.emerald, t: 'Rubrica Emergenze: nuova sezione dedicata con contatti H24' },
            { c: C.gold, t: 'Indice Efficienza energetica: supporto hotel All-Electric con costanti calibrate (k=80 per kWh)' },
            { c: C.gold, t: 'Trend Indice Efficienza per hotel: grafico con finestra mobile 12 mesi' },
            { c: C.cyan, t: 'Storico manutenzioni programmate completate: nuova sezione raggruppata per hotel' },
            { c: C.terra, t: 'Storage foto migrato a GridFS (più affidabile)' },
          ]},
          { v: 'v2.8', d: '02 Giugno 2026', tag: 'PREV', tagC: C.textDim, items: [
            { c: C.gold, t: 'Compressione foto lato client (browser-image-compression)' },
            { c: C.cyan, t: 'Combobox autocomplete camere/aree' },
            { c: C.emerald, t: 'Dashboard tecnico: visualizzazione manutenzioni programmate assegnate' },
          ]},
        ].map((r, i) => (
          <div key={r.v} style={{
            background: C.surf, borderRadius: 14, padding: 22,
            border: `1px solid ${i === 0 ? C.emerald + '44' : C.border}`,
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
              <span style={{ fontFamily: fontHead, fontSize: 22, fontWeight: 600 }}>{r.v}</span>
              <span style={{ fontSize: 9.5, fontWeight: 700, padding: '3px 8px', borderRadius: 4,
                            background: `${r.tagC}22`, color: r.tagC, letterSpacing: '0.1em' }}>{r.tag}</span>
              <span style={{ fontSize: 11.5, color: C.textSec }}>· {r.d}</span>
            </div>
            <ul style={{ margin: 0, padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 9 }}>
              {r.items.map((it, j) => (
                <li key={j} style={{ display: 'flex', alignItems: 'flex-start', gap: 12, fontSize: 13 }}>
                  <span style={{ width: 6, height: 6, borderRadius: '50%', background: it.c, marginTop: 6, flexShrink: 0 }} />
                  <span>{it.t}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </Wrap>
  );
}

// ============================================================================
// 7. SYSTEM HEALTH (live)
// ============================================================================
export function ScreenSystemHealth() {
  return (
    <Wrap>
      <PageHeader over="Sistema · Diagnostics" title="System Health"
        sub="Stato in tempo reale di tutti i servizi" />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 14, marginBottom: 18 }}>
        <Stat label="Uptime 30g" v="99.94%" sub="target 99.5%" c={C.emerald} />
        <Stat label="Latenza media" v="118 ms" sub="API response p95" c={C.gold} />
        <Stat label="Errori ultimo h" v="0" sub="5xx server-side" c={C.emerald} />
        <Stat label="Storage usato" v="12.4 GB" sub="su 50 GB · 25%" c={C.cyan} />
      </div>
      <Card title="Servizi monitorati" sub="Stato live · pinged ogni 60 sec">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {[
            { i: Server, n: 'Backend FastAPI', s: 'OK', c: C.emerald, lat: '88 ms', last: '12 sec' },
            { i: Database, n: 'MongoDB Atlas', s: 'OK', c: C.emerald, lat: '4 ms', last: '8 sec' },
            { i: HardDrive, n: 'GridFS Storage', s: 'OK', c: C.emerald, lat: '22 ms', last: '14 sec' },
            { i: Bell, n: 'Web Push (VAPID)', s: 'OK', c: C.emerald, lat: '142 ms', last: '20 sec' },
            { i: FileText, n: 'SMTP Aruba', s: 'WARN', c: C.amber, lat: '1.2 s', last: '40 sec' },
            { i: Wifi, n: 'CDN edge nodes', s: 'OK', c: C.emerald, lat: '38 ms', last: '6 sec' },
          ].map((s, i) => (
            <div key={i} style={{ display: 'grid',
                                  gridTemplateColumns: '24px 1.5fr 90px 100px 100px 30px',
                                  gap: 14, padding: '11px 14px', alignItems: 'center', fontSize: 13,
                                  background: 'rgba(255,255,255,0.012)', borderRadius: 9,
                                  border: `1px solid ${s.s !== 'OK' ? s.c + '44' : C.border}` }}>
              <s.i size={15} color={s.c} />
              <span style={{ fontWeight: 600 }}>{s.n}</span>
              <span style={{ fontSize: 10, fontWeight: 700, padding: '3px 8px', borderRadius: 4,
                            background: `${s.c}22`, color: s.c, letterSpacing: '0.08em', textAlign: 'center' }}>{s.s}</span>
              <span style={{ color: C.textSec, fontSize: 12 }}>{s.lat}</span>
              <span style={{ color: C.textSec, fontSize: 12 }}>{s.last} fa</span>
              <RefreshCw size={13} color={C.textSec} style={{ cursor: 'pointer' }} />
            </div>
          ))}
        </div>
      </Card>
    </Wrap>
  );
}

// ============================================================================
// 8. CLUSTER DASHBOARD (live)
// ============================================================================
export function ScreenCluster() {
  return (
    <Wrap>
      <PageHeader over="Multi-property · Cluster" title="Vista cluster"
        sub="Confronto fianco a fianco di hotel comparabili" />
      <div style={{ display: 'flex', gap: 10, marginBottom: 18, flexWrap: 'wrap' }}>
        {['Tutti', 'Cluster Nord (Milano+Venezia)', 'Cluster Centro (Firenze+Roma)', 'All-Electric only'].map((p, i) => (
          <button key={p} style={{
            padding: '8px 14px', borderRadius: 999, fontSize: 12,
            background: i === 1 ? `${C.gold}22` : C.surf,
            color: i === 1 ? C.gold : C.textSec,
            border: `1px solid ${i === 1 ? C.gold + '55' : C.border}`,
            fontWeight: i === 1 ? 600 : 400,
          }}>{p}</button>
        ))}
      </div>
      <div style={{ background: C.surf, borderRadius: 14, border: `1px solid ${C.border}`, overflow: 'hidden' }}>
        <div style={{ display: 'grid',
                      gridTemplateColumns: '160px repeat(3, 1fr)',
                      gap: 0, borderBottom: `1px solid ${C.border}` }}>
          <div style={{ padding: 18, ...overline }}>Metrica</div>
          {['Galleria', 'Arcimboldi', 'Vivaldi'].map(h => (
            <div key={h} style={{ padding: 18, borderLeft: `1px solid ${C.border}` }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <Building2 size={14} color={C.gold} />
                <span style={{ fontWeight: 600, fontSize: 14 }}>{h}</span>
              </div>
              <div style={{ fontSize: 11, color: C.textSec, marginTop: 4 }}>Cluster Nord</div>
            </div>
          ))}
        </div>
        {[
          ['Camere totali', '96', '124', '52'],
          ['Occupancy media', '84.5%', '78.2%', '91.1%'],
          ['Ticket / mese', '47', '63', '21'],
          ['MTTR medio', '2h 14m', '3h 02m', '1h 48m'],
          ['Indice efficienza', '81.5', '84.1', '71.6'],
          ['Spesa manut. annua', '€ 84.200', '€ 112.500', '€ 38.700'],
        ].map((row, i) => (
          <div key={i} style={{ display: 'grid',
                                gridTemplateColumns: '160px repeat(3, 1fr)',
                                borderBottom: i < 5 ? `1px solid ${C.border}` : 'none' }}>
            <div style={{ padding: 16, fontSize: 12.5, color: C.textSec }}>{row[0]}</div>
            {row.slice(1).map((v, j) => (
              <div key={j} style={{ padding: 16, borderLeft: `1px solid ${C.border}`,
                                    fontFamily: fontHead, fontSize: 16, fontWeight: 600 }}>{v}</div>
            ))}
          </div>
        ))}
      </div>
    </Wrap>
  );
}

// ============================================================================
// 9. INVESTOR LANDING (live)
// ============================================================================
export function ScreenInvestor() {
  return (
    <div style={{ background: C.bg, color: C.text, fontFamily: 'Inter', minHeight: '100%',
                  backgroundImage: `radial-gradient(ellipse 80% 50% at 50% -10%, ${C.goldGlow}, transparent)` }}>
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '60px 36px' }}>
        <div style={{ ...overline, color: C.gold, marginBottom: 12 }}>Investor relations</div>
        <h1 style={{ fontFamily: fontHead, fontSize: 56, fontWeight: 600, margin: 0,
                     letterSpacing: '-0.035em', lineHeight: 1.05, maxWidth: 800 }}>
          La piattaforma operations<br />per gruppi alberghieri di livello.
        </h1>
        <p style={{ color: C.textSec, fontSize: 16, marginTop: 22, maxWidth: 700, lineHeight: 1.6 }}>
          HostFix gestisce manutenzioni, ticket, consumi energetici e benchmark multi-hotel
          per Invest Hospitality. Dati operativi del gruppo · Q2 2026.
        </p>
        <div style={{ display: 'flex', gap: 12, marginTop: 28 }}>
          <button style={primaryBtn}>Scarica Pitch Deck</button>
          <button style={secondaryBtn}>Business Case PDF</button>
          <button style={secondaryBtn}>One-Pager</button>
        </div>

        <div style={{ marginTop: 60, display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 24 }}>
          {[
            ['6', 'Hotel del Gruppo'],
            ['2.847', 'Ticket gestiti YTD'],
            ['78.4', 'Indice efficienza medio'],
            ['€ 421k', 'Costi manut. risparmiati'],
          ].map(([n, l]) => (
            <div key={l}>
              <div style={{ fontFamily: fontHead, fontSize: 48, fontWeight: 600, color: C.gold,
                            letterSpacing: '-0.04em', lineHeight: 1 }}>{n}</div>
              <div style={{ fontSize: 12, color: C.textSec, marginTop: 8, letterSpacing: '0.1em',
                            textTransform: 'uppercase' }}>{l}</div>
            </div>
          ))}
        </div>

        <div style={{ marginTop: 60, padding: 28, borderRadius: 14,
                      background: C.surf, border: `1px solid ${C.border}` }}>
          <div style={{ ...overline, marginBottom: 12 }}>Documenti commerciali</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
            {['Pitch Deck · 12 slide', 'Business Case · 18 pp', 'One-Pager · 1 pagina'].map(d => (
              <div key={d} style={{ padding: '14px 16px', background: C.bg, borderRadius: 10,
                                    border: `1px solid ${C.border}`, display: 'flex',
                                    alignItems: 'center', gap: 10, cursor: 'pointer' }}>
                <FileText size={15} color={C.gold} />
                <span style={{ flex: 1, fontSize: 13 }}>{d}</span>
                <ChevronRight size={13} color={C.textSec} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

// ============================================================================
// 10. ADMIN TOOLS (live)
// ============================================================================
export function ScreenAdminTools() {
  return (
    <Wrap>
      <PageHeader over="Sistema · Tools admin" title="Admin Tools"
        sub="Strumenti riservati al super_admin · operazioni sensibili sul DB" />
      <div style={{ padding: '14px 18px', background: `${C.terra}11`, border: `1px solid ${C.terra}44`,
                    borderRadius: 10, marginBottom: 18, display: 'flex', alignItems: 'flex-start', gap: 10 }}>
        <Shield size={15} color={C.terra} style={{ marginTop: 2 }} />
        <div style={{ fontSize: 12.5, color: C.textSec, lineHeight: 1.55 }}>
          Le azioni in questa pagina <b style={{ color: C.terra }}>modificano dati strutturali</b>.
          Sono idempotenti e sicure ma vanno usate consapevolmente. Ogni operazione è loggata e firmata.
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 14 }}>
        {[
          { i: RefreshCw, t: 'Sincronizza categorie standard', d: 'Aggiunge le categorie ufficiali mancanti senza toccare quelle esistenti. Sicuro.', btn: 'Esegui sync', c: C.emerald, badge: 'SAFE' },
          { i: Database, t: 'Ricalcola indici efficienza', d: 'Forza il ricalcolo dell\'Indice di Efficienza per tutti gli hotel sulla base dei record correnti.', btn: 'Ricalcola', c: C.gold, badge: 'SAFE' },
          { i: Archive, t: 'Archivia ticket > 18 mesi', d: 'Sposta i ticket chiusi più vecchi di 18 mesi in tickets_archive. Reversibile entro 30 giorni.', btn: 'Avvia archiviazione', c: C.amber, badge: 'CARE' },
          { i: GitBranch, t: 'Export backup completo', d: 'Genera un dump JSON di tutte le collezioni e lo carica su storage esterno.', btn: 'Genera backup', c: C.cyan, badge: 'SAFE' },
        ].map((tool, i) => (
          <div key={i} style={{ background: C.surf, borderRadius: 12, padding: 20,
                                border: `1px solid ${C.border}` }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
              <div style={{ width: 36, height: 36, borderRadius: 9, background: `${tool.c}22`,
                            display: 'grid', placeItems: 'center' }}>
                <tool.i size={16} color={tool.c} />
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{tool.t}</div>
                <span style={{ fontSize: 9.5, fontWeight: 700, padding: '2px 7px', borderRadius: 4,
                              background: tool.badge === 'SAFE' ? `${C.emerald}22` : `${C.amber}22`,
                              color: tool.badge === 'SAFE' ? C.emerald : C.amber,
                              letterSpacing: '0.1em', marginTop: 4, display: 'inline-block' }}>{tool.badge}</span>
              </div>
            </div>
            <p style={{ fontSize: 12.5, color: C.textSec, margin: '10px 0 14px', lineHeight: 1.5 }}>{tool.d}</p>
            <button style={{ ...secondaryBtn, fontSize: 12.5, padding: '8px 14px' }}>{tool.btn}</button>
          </div>
        ))}
      </div>
    </Wrap>
  );
}

// ============================================================================
// 11. SCHEDULED MAINTENANCE DETAIL (live)
// ============================================================================
export function ScreenSchedDetail() {
  return (
    <Wrap>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 18 }}>
        <button style={{ ...secondaryBtn, padding: '8px 12px' }}>
          ← Tutte le manutenzioni
        </button>
        <span style={{ fontFamily: 'monospace', fontSize: 12, color: C.textSec }}>MNT-128</span>
        <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.1em',
                      padding: '4px 10px', borderRadius: 5,
                      background: `${C.gold}22`, color: C.gold }}>TRIMESTRALE</span>
        <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.08em',
                      padding: '4px 10px', borderRadius: 5,
                      background: `${C.emerald}22`, color: C.emerald }}>IN CORSO</span>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1.6fr 1fr', gap: 18 }}>
        <div>
          <h1 style={{ fontFamily: fontHead, fontSize: 28, fontWeight: 600, margin: 0,
                       letterSpacing: '-0.02em', lineHeight: 1.2 }}>
            Sanificazione ascensori · Cabina A + B
          </h1>
          <div style={{ display: 'flex', gap: 16, marginTop: 12, fontSize: 12.5, color: C.textSec, flexWrap: 'wrap' }}>
            <span>📅 Schedulata: <b style={{ color: C.text }}>Domenica 12 Giugno</b></span>
            <span>🏨 Hotel Galleria</span>
            <span>👷 Luca Marini</span>
            <span>🔁 Ogni 90 giorni</span>
          </div>

          <div style={{ marginTop: 28 }}>
            <div style={{ ...overline, marginBottom: 12 }}>Checklist · 12 task</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {[
                { d: 1, t: 'Cabina A · Disinfezione pulsantiera interna', s: 'done' },
                { d: 2, t: 'Cabina A · Disinfezione pulsantiera esterna piani 1-5', s: 'done' },
                { d: 3, t: 'Cabina A · Sanificazione corrimano', s: 'done' },
                { d: 4, t: 'Cabina A · Pulizia ventilazione e filtri', s: 'inprogress' },
                { d: 5, t: 'Cabina A · Verifica luci emergenza', s: 'pending' },
                { d: 6, t: 'Cabina B · Disinfezione pulsantiera interna', s: 'pending' },
                { d: 7, t: 'Cabina B · Disinfezione pulsantiera esterna piani 1-5', s: 'pending' },
              ].map(c => (
                <div key={c.d} style={{
                  display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px',
                  background: 'rgba(255,255,255,0.012)', borderRadius: 9, border: `1px solid ${C.border}`,
                }}>
                  <CheckCircle2 size={16} color={
                    c.s === 'done' ? C.emerald : c.s === 'inprogress' ? C.amber : C.textDim
                  } />
                  <span style={{ flex: 1, fontSize: 13,
                                 textDecoration: c.s === 'done' ? 'line-through' : 'none',
                                 color: c.s === 'done' ? C.textSec : C.text }}>{c.t}</span>
                  <span style={{ fontSize: 10.5, fontWeight: 600, color: 
                    c.s === 'done' ? C.emerald : c.s === 'inprogress' ? C.amber : C.textDim,
                    letterSpacing: '0.08em', textTransform: 'uppercase',
                  }}>{c.s === 'done' ? 'fatto' : c.s === 'inprogress' ? 'in corso' : 'da fare'}</span>
                </div>
              ))}
            </div>
            <div style={{ marginTop: 14, padding: '12px 16px', background: 'rgba(255,255,255,0.018)',
                          borderRadius: 9, fontSize: 12.5, color: C.textSec }}>
              <b style={{ color: C.emerald }}>3/7</b> task completate (43%) · Stima rimanente: ~2h 20min
            </div>
          </div>
        </div>

        <div>
          <Card title="Progress">
            <div style={{ fontFamily: fontHead, fontSize: 56, fontWeight: 600,
                          color: C.emerald, letterSpacing: '-0.04em', lineHeight: 1 }}>43%</div>
            <div style={{ height: 8, background: C.bg, borderRadius: 4, marginTop: 14, overflow: 'hidden' }}>
              <div style={{ width: '43%', height: '100%', background: C.emerald }} />
            </div>
            <div style={{ fontSize: 11.5, color: C.textSec, marginTop: 10 }}>
              Iniziata: <b style={{ color: C.text }}>Sab 11 Giu · 14:20</b><br />
              Auto-rollover prossima esecuzione: ~10 Set 2026
            </div>
          </Card>
          <div style={{ height: 14 }} />
          <Card title="Storico esecuzioni">
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {[
                ['12 Mar 2026', '12/12', C.emerald],
                ['12 Dic 2025', '12/12', C.emerald],
                ['12 Set 2025', '11/12', C.amber],
              ].map(([d, p, c], i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px',
                                      background: 'rgba(255,255,255,0.012)', borderRadius: 8,
                                      border: `1px solid ${C.border}`, fontSize: 12.5 }}>
                  <CheckCircle2 size={14} color={c} />
                  <span style={{ flex: 1 }}>{d}</span>
                  <span style={{ color: c, fontWeight: 600 }}>{p}</span>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </Wrap>
  );
}

// ============================================================================
// Helper component
// ============================================================================
const Stat = ({ label, v, sub, c }) => (
  <div style={{ background: C.surf, borderRadius: 12, padding: 18, border: `1px solid ${C.border}` }}>
    <div style={{ ...overline, marginBottom: 8 }}>{label}</div>
    <div style={{ fontFamily: fontHead, fontSize: 28, fontWeight: 600, color: c,
                  letterSpacing: '-0.03em', lineHeight: 1 }}>{v}</div>
    <div style={{ fontSize: 11, color: C.textSec, marginTop: 6 }}>{sub}</div>
  </div>
);
